/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReferralCodeResponse
 */
export interface GetReferralCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof GetReferralCodeResponse
     */
    referralCode: string;
}

/**
 * Check if a given object implements the GetReferralCodeResponse interface.
 */
export function instanceOfGetReferralCodeResponse(value: object): value is GetReferralCodeResponse {
    if (!('referralCode' in value) || value['referralCode'] === undefined) return false;
    return true;
}

export function GetReferralCodeResponseFromJSON(json: any): GetReferralCodeResponse {
    return GetReferralCodeResponseFromJSONTyped(json, false);
}

export function GetReferralCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferralCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referralCode': json['referralCode'],
    };
}

  export function GetReferralCodeResponseToJSON(json: any): GetReferralCodeResponse {
      return GetReferralCodeResponseToJSONTyped(json, false);
  }

  export function GetReferralCodeResponseToJSONTyped(value?: GetReferralCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralCode': value['referralCode'],
    };
}

